import { z } from 'zod';
const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
// Mirrors the real `announcements` table: opposition_id + description are NOT NULL,
// dates are registration_deadline, visibility is the boolean is_active.
export const createAnnouncementSchema = z.object({
    opposition_id: z.string().uuid(),
    title: z.string().min(1).max(300),
    description: z.string().min(1).max(5000),
    exam_date: z.string().regex(dateRegex, 'Formato: YYYY-MM-DD').optional(),
    registration_deadline: z.string().regex(dateRegex, 'Formato: YYYY-MM-DD').optional(),
    official_url: z.string().url().max(2000).optional(),
    is_active: z.boolean().default(true),
});
export const updateAnnouncementSchema = z.object({
    opposition_id: z.string().uuid().optional(),
    title: z.string().min(1).max(300).optional(),
    description: z.string().min(1).max(5000).optional(),
    exam_date: z.string().regex(dateRegex, 'Formato: YYYY-MM-DD').nullable().optional(),
    registration_deadline: z.string().regex(dateRegex, 'Formato: YYYY-MM-DD').nullable().optional(),
    official_url: z.string().url().max(2000).nullable().optional(),
    is_active: z.boolean().optional(),
});
export const createAnnouncementUpdateSchema = z.object({
    title: z.string().min(1).max(300),
    content: z.string().min(1).max(10000),
});
//# sourceMappingURL=announcement.schema.js.map